import React, { lazy, Suspense, useState } from "react";

import { sampleUsers, toolstabs } from "./Data";
import Tabs from "./Tabs";
import useUserRole from "../../app/auth/useUserRole";

const ToolManagement = lazy(() => import("./ToolManagement"));
const ToolRegistration = lazy(() => import("./ToolRegistration"));
const ToolApproval = lazy(() => import("./ToolApproval"));
const TagManagement = lazy(() => import("./TagManagement"));
const TagRegistrations = lazy(() => import("./TagRegistrations"));

export default function ToolManagementLandingPageIndex() {
  const [activeTab, setActiveTab] = useState(0);
  const userRole = useUserRole();

  const filteredTabs = toolstabs.filter((tab) => {
    if (tab === "TOOL APPROVAL" && userRole !== "Admin") {
      return false;
    }
    return true;
  });

  const getComponentTabIndex = () => {
    if (userRole === "Admin") {
      return activeTab;
    }
    const activeName = filteredTabs[activeTab];
    return toolstabs.indexOf(activeName);
  };

  const componentTabIndex = getComponentTabIndex();
  const tabLoadingFallback = (
    <div
      style={{
        marginTop: 16,
        padding: 20,
        borderRadius: 8,
        background: "#ffffff",
        color: "#666",
      }}
    >
      Loading...
    </div>
  );

  return (
    <div
      style={{
        borderRadius: 8,
        padding: 32,
        // margin: "84px 40px 100px 40px",
        minHeight: "calc(100vh - 124px)",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}
      className="bg-[#bb1ccc]/5"
    >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={filteredTabs} />

      <Suspense fallback={tabLoadingFallback}>
        {componentTabIndex === 0 && (
          <>
            <ToolManagement sampleUsers={sampleUsers} />
          </>
        )}

        {componentTabIndex === 1 && (
          <>
            <ToolRegistration />
          </>
        )}

        {componentTabIndex === 2 && (
          <ToolApproval />
        )}

        {componentTabIndex === 3 && (
          <TagManagement />
        )}

        {componentTabIndex === 4 && (
          <TagRegistrations />
        )}
      </Suspense>
    </div>
  );
}
